import { type ReactNode } from 'react';
import { useUserLocation } from '@/hooks/useUserLocation';
import { UserLocationContext } from './UserLocationContext';

export function UserLocationProvider({ children }: { children: ReactNode }) {
  const locationData = useUserLocation();

  return (
    <UserLocationContext.Provider
      value={{
        ...locationData,
        hasLocation: !!locationData.location,
      }}
    >
      {children}
    </UserLocationContext.Provider>
  );
}
